import { render, staticRenderFns } from "./CreateUserModal.vue?vue&type=template&id=65af20ec&scoped=true"
import script from "./CreateUserModal.vue?vue&type=script&lang=ts"
export * from "./CreateUserModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateUserModal.vue?vue&type=style&index=0&id=65af20ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af20ec",
  null
  
)

export default component.exports